/**
 * Meta Graph API version the browser uses (JS SDK init, template URLs).
 *
 * Must match META_GRAPH_API_VERSION in server/src/config/constants.ts — the
 * server mints the tokens and the dialogs, and an SDK pinned to a different
 * version is how "works on the server, fails in the popup" happens. Bump both
 * together.
 */
export const META_GRAPH_API_VERSION = 'v25.0';
